"use client";
import React, { useEffect } from "react";
import { Box } from "@dxp-feed/ui";
import ImageWrapper from "@/components/ImageWrapper";

interface LoaderProps {
  className?: string;
}

const Loader = ({ className }: LoaderProps) => {
  // useEffect(() => {
  //   // Add overflow-hidden to the body when the Loader is mounted
  //   document.body.classList.add("overflow-hidden");

  //   return () => {
  //     // Remove overflow-hidden from the body when the Loader is unmounted
  //     document.body.classList.remove("overflow-hidden");
  //   };
  // }, []);

  return (
    <Box
      as="div"
      className={`z-[19] min-h-[300px] h-full w-full flex items-center justify-center ${className ?? ""}`}
    >
      <ImageWrapper
        src="/loader.svg"
        width={50}
        height={50}
        alt="loader"
        className="rounded-[50%]"
      />
    </Box>
  );
};
export default Loader;
